import { Trans } from '@lingui/macro'
import React, { FC, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { ButtonPrimary } from 'front-end/src/components'
import IconLogin from 'front-end/src/components/common/icon/IconLogin'
import IconRefresh from 'front-end/src/components/common/icon/IconRefresh'
import { notification } from 'front-end/src/components/common/notifications/Notifications'

export const QuizSaveAnswer: FC<{ onSave: any; disabled: boolean }> = ({
  onSave,
  disabled
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const location = useLocation()

  const onClick = async () => {
    setIsLoading(true)
    try {
      await onSave()
    } catch (err) {
      notification.error(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      className={`QuizElement__submit__wrapper ${isLoading ? 'checking' : ''}`}
    >
      <div>
        <ButtonPrimary
          isLoading={isLoading}
          onClick={onClick}
          disabled={
            disabled ||
            location.pathname.endsWith('preview') ||
            location.pathname.startsWith('/topic-enrolment')
          }
          leftIcon={isLoading ? <IconRefresh /> : <IconLogin />}
        >
          {/* don't delete this span, it's essential (if page is translated, and button is clicked it throws error otherwise)*/}
          <span>
            {isLoading ? (
              <Trans>Checking...</Trans>
            ) : (
              <Trans>Save answer</Trans>
            )}
          </span>
        </ButtonPrimary>
      </div>
    </div>
  )
}
